
const { ccclass, property } = cc._decorator;

@ccclass
export default class MyEmojiItem extends cc.Component {
    

    onload(){
        cc.log("aaaa")
    }
    countTimeDestory(){
        this.scheduleOnce(() => {
            this.node.active=false
            this.node.destroy()
        }, 3);
    }
    

}